(() => {
  const initialiseGallery = (gallery) => {
    if (!gallery || gallery.dataset.yhsPdpV2Ready === 'true') return;
    gallery.dataset.yhsPdpV2Ready = 'true';

    const buttons = [...gallery.querySelectorAll('[data-yhs-pdp-v2-media-button]')];
    const slides = [...gallery.querySelectorAll('[data-yhs-pdp-v2-slide]')];
    if (buttons.length === 0 || slides.length === 0) return;

    const activate = (button, moveFocus = false) => {
      const mediaId = button.dataset.mediaId;

      buttons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      slides.forEach((slide) => {
        const isActive = slide.dataset.mediaId === mediaId;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);

        if (!isActive) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      if (moveFocus) button.focus();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        const currentIndex = buttons.indexOf(button);
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          activate(buttons[nextIndex], true);
        }
      });
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const activeButton = buttons.find((button) => button.getAttribute('aria-current') === 'true');
      activeButton?.focus();
    });
  };

  const initialiseVariantState = (main) => {
    if (!main || main.dataset.yhsPdpV2VariantReady === 'true') return;
    main.dataset.yhsPdpV2VariantReady = 'true';

    const selector = main.querySelector('[data-yhs-pdp-v2-variant]');
    const variantInput = main.querySelector('[data-yhs-pdp-v2-variant-id]');
    if (!selector || !variantInput) return;

    const update = () => {
      const option = selector.selectedOptions[0];
      if (!option) return;

      variantInput.value = option.value;
    };

    selector.addEventListener('change', update);
    update();
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.('[data-yhs-pdp-v2-gallery]')) initialiseGallery(root);
    if (root.matches?.('[data-yhs-pdp-v2-main]')) initialiseVariantState(root);
    root.querySelectorAll?.('[data-yhs-pdp-v2-gallery]').forEach(initialiseGallery);
    root.querySelectorAll?.('[data-yhs-pdp-v2-main]').forEach(initialiseVariantState);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
